/** Utah's words for learn.ts. */
export const LEARN_UT = {
  /** Title of the required course: Utah's food handler permit course. */
  courseTitle: "Utah food handler permit course",
  /** Why: Utah requires a state-approved course within 14 days and the county permit within 30 days, valid 3 years (Utah Code 26B-7-413). */
  courseWhy: "Utah law requires food handlers to finish a state-approved course within 14 days of starting and get a permit from the county health department within 30 days. The permit is valid 3 years.",
  /** Citation: Utah Code 26B-7-413 (food handler permit). */
  courseCitation: "Utah Code 26B-7-413",
  /** Thermometer lesson point: water boils below 212F at Utah altitude, about 203F in Salt Lake City. */
  boilingPoint: "Don't use boiling water in Utah; it boils at about 203°F in Salt Lake City.",
  /** Thermometer quiz question naming the state. */
  calibrateQuestion: "How do you calibrate in Utah?",
} as const;
